
/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  // ここに処理関数を記述
});

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */
let currentWidth = window.innerWidth;
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (currentWidth === window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    // ここに処理関数を記述
    currentWidth = window.innerWidth;
  }, 200);
});